import React from 'react';
import StickyStepsRail from '../shared/StickyStepsRail';
import SpirographCanvas from '../shared/SpirographCanvas';

const steps = [
  {
    id: 'ingest',
    title: 'Ingests',
    description:
      'Every data point flows in — from utility bills to supplier CSVs, IoT meters, and ERP exports. The ingestion layer normalizes units, timezones, and taxonomies before anything else runs.',
    pills: ['CSV', 'API', 'IoT streams', 'ERP connectors'],
    status: 'Sub-second normalization',
  },
  {
    id: 'routes',
    title: 'Routes',
    description:
      'An AI router scores each disclosure request and sends it to the model that answers best — balancing coverage of CSRD, GRI, TCFD and AASB S2 against latency and cost in real time.',
    pills: ['by framework', 'by materiality', 'by cost', 'by confidence'],
    status: 'Sub-50ms routing decisions',
  },
  {
    id: 'validates',
    title: 'Validates',
    description:
      'Every metric is cross-checked against the framework rulebook, prior filings, and industry benchmarks. Anomalies are flagged with an audit trail before they ever reach a report.',
    pills: ['dual materiality', 'variance', 'peer benchmarks', 'auditor rules'],
    status: 'Full traceability, always',
  },
  {
    id: 'reports',
    title: 'Reports',
    description:
      'Draft disclosures compile into branded PDF, Word (Docx), XBRL for regulators, Excel and PowerPoint — with citations back to the source data on every line.',
    pills: ['PDF', 'XBRL', 'Docx', 'XLSX', 'PPTX'],
    status: 'Regulator-ready in one click',
  },
];

const Header = () => (
  <div>
    <div className="text-xs font-bold uppercase tracking-[0.28em] text-blue-600 mb-3">
      The engine
    </div>
    <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight text-slate-900">
      Under{' '}
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-emerald-500">
        the hood
      </span>
      .
    </h2>
  </div>
);

const SideArt = () => (
  <SpirographCanvas
    size={460}
    petals={44}
    strokeColor="rgba(59,130,246,0.22)"
    ringColor="rgba(16,185,129,0.4)"
    coreColor="rgba(255,255,255,0.95)"
    speed={0.06}
  />
);

const UnderTheHoodSection = () => {
  return (
    <section className="relative bg-gradient-to-b from-white via-slate-50 to-white">
      <StickyStepsRail
        steps={steps}
        stepScrollVh={70}
        header={<Header />}
        sideDecoration={<SideArt />}
      />
    </section>
  );
};

export default UnderTheHoodSection;
